import React, { useContext } from 'react'
import Hero from './Components/Hero'
import HomeAboutSection from './Components/HomeAboutSection'
import HomeCarSection from './Components/HomeCarSection'
import './Home.css'
import CarShorts from "./Components/CarShorts";
import AppPromo from './Components/AppPromo'
import { HomePageSkeleton } from '../Components/Skeleton/Skeleton'
import PageLoadGate from '../Components/Skeleton/PageLoadGate'
import ScrollReveal from '../../shared/components/motion/ScrollReveal'
import { MyContext } from '../Context/MyContext'

const Home = () => {
  const { home_page } = useContext(MyContext)
  const visibleSections = home_page.sections.filter((section) => section.show)
  const ownedStockSection = visibleSections.find((section) => section.key === 'owned_stock')
  const otherCarSections = visibleSections.filter((section) => section.key !== 'owned_stock')

  return (
    <div className="home-wrapper">
      <Hero />
      <PageLoadGate skeleton={<HomePageSkeleton />} delay={380} home>
        <div className="home-content">
          {ownedStockSection && (
            <ScrollReveal delay={0.04}>
              <HomeCarSection section={ownedStockSection} />
            </ScrollReveal>
          )}
          <ScrollReveal delay={0.06} amount={0.15}>
            <HomeAboutSection />
          </ScrollReveal>
          {otherCarSections.map((section, index) => (
            <ScrollReveal key={section.key} delay={0.08 + index * 0.06}>
              <HomeCarSection section={section} />
            </ScrollReveal>
          ))}
          <ScrollReveal delay={0.08}>
            <CarShorts />
          </ScrollReveal>
          <ScrollReveal delay={0.1}>
            <AppPromo />
          </ScrollReveal>
        </div>
      </PageLoadGate>
    </div>
  )
}

export default Home
